import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

const STORAGE_KEY = "chasqui_cookie_consent_v1";

function applyConsent(mode) {
  if (typeof window === "undefined" || !window.gtag) return;
  if (mode === "all") {
    window.gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
      functionality_storage: "granted",
      personalization_storage: "granted",
    });
  } else {
    window.gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
      functionality_storage: "granted",
      personalization_storage: "denied",
    });
  }
}

export default function CookieBanner() {
  const { t, prefix } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        setVisible(true);
      } else {
        applyConsent(stored);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const choose = (mode) => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* ignore */
    }
    applyConsent(mode);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label={t("cookies.banner.title")}
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4"
    >
      <div className="mx-auto max-w-5xl rounded-lg border border-slate-800 bg-slate-900 p-5 shadow-lg text-slate-100">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="max-w-3xl">
            <p className="font-heading text-base font-semibold text-white">
              {t("cookies.banner.title")}
            </p>
            <p className="mt-1 text-sm text-slate-300">
              {t("cookies.banner.body")}{" "}
              <Link
                to={`${prefix}/cookies`}
                data-testid="cookie-banner-more"
                className="underline underline-offset-2 text-teal-400 hover:text-teal-300"
              >
                {t("cookies.banner.link")}
              </Link>
              .
            </p>
          </div>
          <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              data-testid="cookie-banner-essential-button"
              onClick={() => choose("essential")}
              className="inline-flex items-center justify-center rounded-md border border-slate-700 px-4 py-2 text-sm font-semibold text-slate-100 hover:bg-slate-800"
            >
              {t("cookies.banner.essentialOnly")}
            </button>
            <button
              type="button"
              data-testid="cookie-banner-accept-button"
              onClick={() => choose("all")}
              className="inline-flex items-center justify-center rounded-md bg-teal-500 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-teal-400"
            >
              {t("cookies.banner.acceptAll")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
